import { App } from "@teamworksdev/react";
import axios from "axios";
import config from "~/config";
import localStorage from "~/services/localStorage";

const baseUrl = import.meta.env?.DEV ? "/api" : config.api.baseUrl;

const api = axios.create({
  baseURL: baseUrl,
  withCredentials: true,
});

api.interceptors.request.use((config) => {
  Object.entries(getAuthHeaders() ?? {}).forEach(([key, value]) => {
    if (!config.headers.has(key)) {
      config.headers.set(key, value);
    }
  });

  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response) {
      throw new Error(error.response.data?.message, { cause: error.response });
    } else {
      throw new Error(error.message);
    }
  },
);

export function getAuthHeaders(targetAppOverride?: string) {
  const accessToken = getAccessToken();
  const targetApp = targetAppOverride || App.hub;
  return accessToken && targetApp
    ? {
        Authorization: `Bearer ${accessToken}`,
        "target-app": targetApp.toString(),
      }
    : undefined;
}

export function getNoCacheHeaders() {
  return {
    "cache-control": "max-age=0",
    expires: "0",
    pragma: "no-cache",
  };
}

export function getAccessToken() {
  return localStorage.getAccessToken();
}

export function getHostName() {
  return location.hostname + (location.port ? `:${location.port}` : "");
}

export default api;
